import { Button, Drawer } from 'antd';
import HistoryPredictions from 'components/HistoryPredictions';
import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';
import CountDownFinal from './CountDownFinal';

const navItems = [
  { name: 'Trang chủ', href: 'https://ps991.com/' },
  { name: 'Dự đoán', href: '/' },
  { name: 'Thể lệ', href: '/rule' },
  { name: 'Kết quả', href: '/prize-structure' }
];

const Header = () => {
  const location = useLocation();
  const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');
  const [isShowMenu, setIsShowMenu] = useState(false);

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.PS99
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || 'https://ps991.com/';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1280px] mx-auto rounded-b-[25px]
            flex items-center justify-center 
             bg-white
            py-1 md:py-3
            px-1 md:px-3 lg:px-10"
      >
        <div className="flex lg:hidden justify-start">
          <Drawer
            placement="left"
            onClose={() => setIsShowMenu(false)}
            open={isShowMenu}
            closeIcon={null}
            width={260}
            bodyStyle={{ padding: 0, position: 'relative' }}
            style={{
              // Hide scrollbar for the Drawer
              overflow: 'auto',
              scrollbarWidth: 'none', // For Firefox
              msOverflowStyle: 'none' // For IE, Edge
            }}
            // For Ant Design Drawer: pass className to customize scrollbar for inner content
            className="drawer-hide-scrollbar"
          >
            {/* Inline scrollbar-hide CSS for injected content */}
            <style>
              {`
                  .drawer-hide-scrollbar {
                    scrollbar-width: none !important;        /* Firefox */
                    -ms-overflow-style: none !important;     /* IE and Edge */
                  }
                  .drawer-hide-scrollbar::-webkit-scrollbar {
                    display: none !important;                /* Chrome, Safari and Opera */
                    width: 0 !important;
                    background: transparent !important;
                  }
                `}
            </style>
            {/* Logo on Top */}
            <div
              className="flex items-center justify-center w-full py-6 border-b border-gray-200"
              style={{ background: '#FFFFFF' }}
            >
              <Link to="/" onClick={() => setIsModalHistory(false)}>
                <img
                  src="/assets/images/header/logo.png"
                  alt="Logo"
                  className="h-[48px] w-auto object-contain mx-auto"
                />
              </Link>
            </div>
            {/* Close Button X */}
            <button
              onClick={() => setIsShowMenu(false)}
              className="absolute top-3 right-3 z-10 hover:opacity-80 transition-opacity"
              aria-label="Đóng menu"
              style={{
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0
              }}
            >
              <img
                src="/assets/images/header/close.png"
                alt="Close"
                className="w-8 h-8 object-contain"
              />
            </button>
            {/* Hide scrollbar for this menu list as well */}
            <div
              className="flex flex-col h-full"
              style={{ background: '#FFFFFF', overflow: 'auto' }}
            >
              <Link
                to="/"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#26A9E0] hover:text-white font-bold text-xl text-[#26A9E0] transition-colors"
              >
                Dự đoán
              </Link>
              <Link
                to="/rule"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#26A9E0] hover:text-white font-bold text-xl text-[#26A9E0] transition-colors"
              >
                Thể lệ
              </Link>
              <Link
                to="/prize-structure"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
                className="flex items-center px-5 py-4 hover:bg-[#26A9E0] hover:text-white font-bold text-xl text-[#26A9E0] transition-colors"
              >
                Kết quả
              </Link>
              <Button
                type="text"
                className="flex items-center justify-start px-5 py-8 font-bold text-xl w-full text-left text-[#26A9E0] hover:bg-[#26A9E0] hover:text-white transition-colors group"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                  setIsModalHistory(true);
                }}
                style={{ color: '#26A9E0', background: 'transparent', border: 'none' }}
              >
                <span className="w-full block transition-colors">Lịch sử</span>
              </Button>
              <Link
                to={settings.link_login}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 26A9E0 font-bold text-xl text-[#26A9E0] transition-colors"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
              >
                Đăng nhập
              </Link>
              <Link
                to={settings.link_register}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center px-5 py-4 hover:bg-[#26A9E0] hover:text-white font-bold text-xl text-[#26A9E0] transition-colors"
                onClick={() => {
                  setIsShowMenu(false);
                  setIsModalHistory(false);
                }}
              >
                Đăng ký
              </Link>
            </div>
          </Drawer>
          <Button type="link" onClick={() => setIsShowMenu(true)}>
            <img
              src="/assets/images/header/menu.png"
              alt=""
              className="h-[32px] w-[32px] md:w-auto object-contain"
            />
          </Button>
        </div>
        <div className="flex justify-center items-center shrink-0">
          <Link key={navItems[0].name} to={navItems[0].href || 'https://ps991.com/'}>
            <img
              src="/assets/images/header/logo.png"
              alt=""
              className="h-[36px] md:h-[50px] mt-2 md:mt-0 w-auto object-contain"
            />
          </Link>
        </div>
        <div className="flex justify-center items-center flex-1">
          <div className="lg:flex hidden flex-row justify-center items-center w-full gap-3 lg:gap-6">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-4 py-1.5 rounded-lg lg:text-[15px] xl:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#26A9E0]'
                    : 'text-[#26A9E0] bg-transparent'
                } ${item.name === 'Trang chủ' ? 'hidden md:block' : ''}`}
              >
                {item.name}
              </Link>
            ))}
            <button
              onClick={() => setIsModalHistory(true)}
              className={`text-center text-[14px] lg:text-[15px] xl:text-[16px] font-semibold text-[#26A9E0] cursor-pointer bg-transparent border-0`}
            >
              Lịch sử
            </button>
          </div>
        </div>
        <div className="flex justify-end shrink-0">
          <div className="flex flex-row justify-end gap-2 h-full">
            <Link
              to={settings.link_login}
              target="_blank"
              className="w-auto h-[26px] md:h-[36px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/login.png"
                alt="Đăng ký"
                className="w-auto h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
            <Link
              to={settings.link_register}
              target="_blank"
              className="w-auto h-[26px] md:h-[36px] flex items-center justify-center"
            >
              <img
                src="/assets/images/header/register.png"
                alt="Đăng ký"
                className="w-auto h-full object-contain transform transition-all duration-150 ease-out hover:scale-105 hover:-translate-y-1 hover:shadow-lg"
              />
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full h-auto flex justify-center items-center relative">
        <img
          src="/assets/images/header/banner_pc.png"
          alt=""
          className="w-full max-w-[600px] h-auto object-contain py-2 md:flex hidden"
        />
        <img
          src="/assets/images/header/banner_mb.png"
          alt=""
          className="w-full max-w-[600px] h-auto object-contain py-2 md:hidden flex"
        />
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 mt-[20px] md:mt-[24px]">
          <CountDownFinal />
        </div>
      </div>

      {/* <div className="flex justify-center items-center w-full px-2 mb-3">
        <div className="md:hidden flex flex-row justify-center items-center w-full gap-2 sm:gap-3 lg:gap-10 py-3 rounded-full bg-white">
          {navItems.map((item) =>
            item.name === 'Trang chủ' ? null : (
              <Link
                key={item.name}
                to={item.href}
                className={`text-center text-[14px] px-5 py-2 rounded-lg sm:text-[16px] font-semibold ${
                  activeNav === item.href
                    ? 'text-[#FFF] bg-[#26A9E0]'
                    : 'text-[#26A9E0] bg-transparent'
                }`}
              >
                {item.name}
              </Link>
            )
          )}
          <button
            onClick={() => setIsModalHistory(true)}
            className={`text-center text-[14px] sm:text-[16px] font-semibold text-[#26A9E0] cursor-pointer bg-transparent border-0`}
          >
            Lịch sử
          </button>
        </div>
      </div> */}

      <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      />
    </div>
  );
};

export default Header;
